import { render, staticRenderFns } from "./ModalMatricular.vue?vue&type=template&id=47a68f91"
import script from "./ModalMatricular.vue?vue&type=script&lang=js"
export * from "./ModalMatricular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports